import React, { useState, useEffect } from 'react';

const LanguageContext = React.createContext({
  language: 'pt-br',
  setLanguage: () => {},
});

function LanguageProvider({ children, locale }) {
  const [language, setLanguage] = useState(locale || 'pt-br');

  useEffect(() => {
    if (locale && locale !== language) {
      setLanguage(locale);
    }
  }, [locale]);

  const value = { language, setLanguage };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export default LanguageContext;

export { LanguageProvider };
